export default __webpack_public_path__ + "static/media/memTeam2.ce2fc0c3.png";